//Container
export const MODULE_LIST = 'module_list';
export const CURRENT_MODULE = 'current_module';
export const CURRENT_CONFIG = 'current_config';
export const CONTAINER_UPDATE_VERSION = 'update_version';
export const CONTAINER_TOGGLE_MENU = 'toggle_menu';
export const CONTAINER_LOADING = 'LOADING';

export const RESET = 'RESET';


//Auth
export const AUTH_USER = 'auth_user';
export const UNAUTH_USER = 'unauth_user';
export const AUTH_ERROR = 'auth_error';
export const UPDATE_SESSION = 'update_session';
export const GET_USER_INFO = 'get_user_info';

export const USER_GET = 'user_get';
export const USER_LIST = 'user_list';

//Finance
export const IMOVEL_GET = 'imovel_get';
export const IMOVEL_LIST = 'imovel_list';
export const IMOVEL_INNER_LIST = 'imovel_inner_list';
export const FICHA_CADASTRAL_GET = 'ficha_cadastral_get';

export const LOTE_SELECTED_ID = 'lote_selected_id';
export const LOTE_GET = 'lote_get';
export const LOTE_PHOTO_GET = 'lote_photo_get';

export const UNIDADE_LIST = 'unidade_list';
export const UNIDADE_INNER_LIST = 'unidade_inner_list';
export const CONFIG_ESTATISTICA_GET = 'config_estatistica_get';

//SYSTEM - Finance
export const CONFIG_FORMULAUPDATE_FIELDS_CONSOLIDACAO_GET = 'config_formulaupdate_fields_consolidacao_get';
export const ULTIMO_UNIDADE_UPDATE_GET = 'ultimo_unidade_update_get';

//Files
export const ARQUIVOS_DIGITALIZADOS_LIST = 'arquivos_digitalizados_list';
export const ARQUIVOS_DIGITALIZADOS_LIST_FAILED = 'arquivos_digitalizados_list_failed';

export const ARQUIVOS_GERAIS_FINANCAS_LIST = 'arquivos_gerais_financas_list';
export const ARQUIVOS_GERAIS_FINANCAS_LIST_FAILED = 'arquivos_gerais_financas_list_failed';

//AreasObservacao
export const AREA_OBSERVACAO_LIST = 'area_observacao_list';
export const AREA_OBSERVACAO_GET = 'area_observacao_get';


//Map
export const CONFIG_MAP_UPDATE = 'config_map_update';
export const CONFIG_MAP_GET_MAP_SERVICES = 'config_map_get_map_services';

//Public
export const PUBLIC_SETTINGS = 'public_settings';

//SystemConfig
export const CONFIG_EMAIL_GET = 'config_email_get';
export const CONFIG_GEOCLOUD_GET = 'config_geocloud_get';
export const CONFIG_STYLE_GET = 'config_style_get';
export const CONFIG_MAP_GET = 'config_map_get';
export const CONFIG_FILE_GET = 'config_file_get';
export const CONFIG_CLIENT_GET = 'config_client_get';
export const CONFIG_SYSTEM_GET = 'config_system_get';
export const SYSTEM_MODULE_LIST = 'system_module_list';

export const SYSTEM_MAP_LIST = 'system_map_list';
export const SYSTEM_MAP_GET = 'system_map_get';
export const MAP_SERVICE_GET = 'map_service_get';
export const MAP_SERVICE_LIST = 'map_service_list';

export const FETCH_MESSAGE = 'fetch_message';

//Queue
export const QUEUE_LIST = 'queue_list';
export const QUEUE_GET_CONFIG = 'queue_get_config';


//Logradouro
export const LOGRADOUROS_LIST = 'logradouros_list';